import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from '../assets/images/logo.png';

const ForgotPasswordForm = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) {
      setError('Email is required.');
      return;
    } else if (!validateEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    // Simulate API call and toast
    toast.success('Reset link sent to your email!', {
      className: 'custom-toast success-toast',
    });

    setTimeout(() => {
      navigate('/signin');
    }, 3000);
  };

  return (
    <>
      {/* Toast container */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        closeOnClick
        pauseOnHover
        draggable
      />
      <div className="login-box">
        <div className="login-logo">
          <img src={logo} alt="Logo" className="logo-image" />
        </div>
        <h2>Forgot Password</h2>
        <p>Remembered your password? <Link to="/signin">Back to Sign in</Link></p>

        <Form onSubmit={handleSubmit} className="form login-form">
          <Form.Group className="mb-4">
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              type="email"
              name="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError('');
              }}
              className={error ? 'error-input' : ''}
              isInvalid={!!error}
            />
            <Form.Control.Feedback type="invalid" className="error-message d-block">
              {error}
            </Form.Control.Feedback>
          </Form.Group>

          <Button type="submit" className="full-btn sign-in-btn">
            Send Reset Link
          </Button>
        </Form>


      </div>
    </>
  );
};

export default ForgotPasswordForm;
